// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"ActivityLogComponent_tableContainer__3nvVQ","dateValues":"ActivityLogComponent_dateValues__30pxz","inputLabels":"ActivityLogComponent_inputLabels__1bV2E"};